import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PageWrapper from "../components/PageWrapper";
import api from "../lib/api";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function InsightDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <PageWrapper testId="insight-detail-page">
        <div className="max-w-[900px] mx-auto px-5 py-32 flex items-center gap-3 text-slate-500">
          <Loader2 className="animate-spin" /> Loading…
        </div>
      </PageWrapper>
    );
  }

  if (notFound || !post) {
    return (
      <PageWrapper testId="insight-detail-page">
        <div className="max-w-[900px] mx-auto px-5 py-32">
          <div className="text-slate-500">Insight not found.</div>
          <Link
            to="/insights"
            className="mt-4 inline-flex items-center gap-2 text-navy"
          >
            <ArrowLeft size={16} /> Back to insights
          </Link>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper testId="insight-detail-page">
      <article className="bg-white">
        <header className="bg-navy text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-grid-navy opacity-30" />
          <div className="relative max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
            <Link
              to="/insights"
              data-testid="insight-back-link"
              className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold transition"
            >
              <ArrowLeft size={14} /> Back to insights
            </Link>
            <div className="mt-7 text-[11px] uppercase tracking-[0.22em] text-gold">
              {post.category}
            </div>
            <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] max-w-4xl">
              {post.title}
            </h1>
            <div className="mt-6 text-sm text-white/60">
              By {post.author}
            </div>
          </div>
        </header>

        {post.cover_image ? (
          <div className="bg-[#F8FAFC]">
            <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 -mt-10 lg:-mt-16 relative">
              <img
                src={post.cover_image}
                alt={post.title}
                className="w-full aspect-[16/9] object-cover border border-slate-200"
              />
            </div>
          </div>
        ) : null}

        <div className="bg-[#F8FAFC] py-20 sm:py-24">
          <div className="max-w-[820px] mx-auto px-5 sm:px-8">
            <div
              data-testid="insight-content"
              className="prose-destineze"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
            <div className="mt-14 pt-10 border-t border-slate-200 flex items-center justify-between">
              <Link
                to="/insights"
                className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] font-semibold text-navy hover:text-gold-500 transition"
              >
                <ArrowLeft size={14} /> All insights
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] font-semibold text-navy hover:text-gold-500 transition"
              >
                Engage our team →
              </Link>
            </div>
          </div>
        </div>
      </article>
    </PageWrapper>
  );
}
